/* ============================================
   ET - Collection Slider — draggable SwiperJS carousel of collection cards.
   No CSS width on slides — Swiper controls slide width via slidesPerView (count),
   configured per section (desktop / mobile). Robustly waits for window.Swiper.
   ============================================ */
(function () {
  'use strict';

  var SEL = '[data-et-cs-swiper]';
  var done = new WeakSet();

  function num(el, attr, fallback) {
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? fallback : v;
  }

  function build(el) {
    if (done.has(el)) return;
    if (typeof window.Swiper !== 'function') return;
    done.add(el);
    /* eslint-disable no-new */
    new window.Swiper(el, {
      slidesPerView: num(el, 'data-slides-m', 1.5),
      spaceBetween: 4,
      grabCursor: true,
      breakpoints: {
        750: { slidesPerView: num(el, 'data-slides-d', 4.5) }
      }
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll(SEL).forEach(build);
  }

  function boot(scope) {
    init(scope);
    if (typeof window.Swiper === 'function') return;
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof window.Swiper === 'function') {
        clearInterval(timer);
        init(document);
      } else if (++tries > 300) {
        clearInterval(timer);
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  window.addEventListener('load', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
})();
